// native pagination styles
.ux-slider-pagination {
  position: absolute;
  text-align: center;
  transform: translate3d(0, 0, 0);
  transition: 300ms opacity;
  z-index: 10;
}

.ux-slider-pagination.swiper-pagination-hidden {
  opacity: 0;
}

/* Common Styles */
.swiper-pagination-fraction,
.swiper-pagination-custom,
.ux-slider-container-horizontal > .swiper-pagination-bullets {
  bottom: 10px;
  left: 0;
  width: 100%;
}

/* Bullets */
.swiper-pagination-bullets-dynamic {
  font-size: 0;
  overflow: hidden;
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
  position: relative;
  transform: scale(0.33);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active {
  transform: scale(1);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main {
  transform: scale(1);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {
  transform: scale(0.66);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {
  transform: scale(0.33);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {
  transform: scale(0.66);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {
  transform: scale(0.33);
}

.ux-slider-pagination .swiper-pagination-bullet {
  background: #000;
  border-radius: 50%;
  display: inline-block;
  height: 8px;
  opacity: 0.2;
  vertical-align: middle;
  width: 8px;
}

//button..swiper-pagination-bullet
.ux-slider-pagination .swiper-pagination-bullet {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: 0;
  box-shadow: none;
  margin: 0;
  padding: 0;
}

.ux-slider-pagination.swiper-pagination-clickable .swiper-pagination-bullet {
  cursor: pointer;
}

.ux-slider-pagination .swiper-pagination-bullet-active {
  background: var(--swiper-pagination-color, var(--swiper-theme-color));
  opacity: 1;
}

.ux-slider-container-vertical > .ux-slider-pagination.swiper-pagination-bullets {
  right: 10px;
  top: 50%;
  transform: translate3d(0, -50%, 0);
}

.ux-slider-container-vertical > .swiper-pagination-bullets .swiper-pagination-bullet {
  display: block;
  margin: 6px 0;
}

.ux-slider-container-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
  top: 50%;
  transform: translateY(-50%);
  width: 8px;
}

.ux-slider-container-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
  display: inline-block;
  transition: 200ms transform, 200ms top;
}

.ux-slider-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
  margin: 0 4px;
}

.ux-slider-container-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
}

.ux-slider-container-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
  transition: 200ms transform, 200ms left;
}

.ux-slider-container-horizontal.ux-slider-container-rtl > .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
  transition: 200ms transform, 200ms right;
}
/* Progress */
.swiper-pagination-progressbar {
  background: rgba(0, 0, 0, 0.25);
  position: absolute;
}

.swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
  background: var(--swiper-pagination-color, var(--swiper-theme-color));
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  transform: scale(0);
  transform-origin: left top;
  width: 100%;
}

.ux-slider-container-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
  transform-origin: right top;
}

.ux-slider-container-horizontal > .swiper-pagination-progressbar,
.ux-slider-container-vertical > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {
  height: 4px;
  left: 0;
  top: 0;
  width: 100%;
}

.ux-slider-container-vertical > .swiper-pagination-progressbar,
.ux-slider-container-horizontal > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {
  height: 100%;
  left: 0;
  top: 0;
  width: 4px;
}

.swiper-pagination-white {
  --swiper-pagination-color: #fff;
}

.swiper-pagination-black {
  --swiper-pagination-color: #000;
}

.swiper-pagination-lock {
  display: none;
}

// custom pagination styles
.ux-slider .ux-slider-pagination {
  align-items: center;
  display: flex;
  height: auto;
  width: auto;
  z-index: $z-index-slider-pagination;

  &__container {
    position: relative;
  }

  &__container--dynamic {
    height: 25px;
    overflow: hidden;
    width: 146px;
  }

  &__navigation-arrow {
    cursor: pointer;
    height: auto;
    padding-left: 5px;
  }

  &__navigation-arrow--prev {
    padding-left: 5px;
    transform: rotate(180deg);
  }

  .swiper-pagination-bullet {
    border-radius: 0;
    cursor: pointer;
    margin: 0 4px;

    &-active {
      background: $color-green;
      cursor: default;
      transform: scale(1.5);
      vertical-align: middle;
    }

    &:focus {
      outline: none;
    }
  }

  &--bottom {
    display: flex;
    justify-content: center;
    padding-top: 20px;
    position: relative;
    width: 100%;
  }

  &--anchor {
    position: absolute;
    transform: translateX(-50%);
  }

  .swiper-pagination-bullet {
    transition: all 0.35s !important;
  }
}

// needed the + 1 specificity
.ux-slider .ux-slider-pagination .ux-slider-pagination__bullet {
  will-change: width margin translate;

  &--invisible {
    backface-visibility: hidden;
    background: transparent;
    height: 0;
    margin: 0;
    padding: 0;
    width: 0;
  }

  &--small {
    backface-visibility: hidden;
    transform: scale(0.85);
    transform-origin: center;
  }

  &--extra-small {
    backface-visibility: hidden;
    height: 4px;
    transform-origin: center;
    //messes up spacing if we scale the last one.
    width: 4px;
  }
}

.ux-slider-inline-pagination-anchor {
  display: block;
  height: $dim-anchor-pagination-vertical;
  margin-bottom: 5px;
  margin-top: $anchor-pagination-margin-vertical;
  width: 100%;
}
